angular.module('unica_track.track_controllers')

.controller('TrackListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	TrackListService, TrackDeleteService
) {

	$scope.trackList = [];

	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadTrackLists = function()
	{
		$scope.showLoader();

		TrackListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.trackList = $scope.trackList.concat( data );
				}
			});
	};

	$scope.loadTrackLists();

	$scope.deleteTrack = function(trackId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare questo track?',
			text: 'Confermi la cancellazione del track?'
		}).then(function() {

			$scope.showLoader();

			TrackDeleteService
				.delete( trackId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.trackList, function(track, key) {
							if ( track.id === trackId ) {
								$scope.trackList.splice(key, 1);
							}
						});

						$scope.showSuccessMsg('Track eliminato con successo!', '');
					}
				});

		}, function() {
			// Cancel
		});
	};

});